import React, { useState } from "react";
import SvgImage from "../../../Icons/Icons";
import "./index.css";
import {
  downloadSalaryAction,
  downloadSalaryCreditSheet,
  uploadSalaryAction,
  uploadSalaryCreditSheet,
} from "../../../../services/Store/Actions/driverslistActions";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import {
  bulkTransferUpload,
  bulkWithdrawlUpload,
  downloadBulkTransferAction,
} from "../../../../services/Store/Actions/walletAction";
import { FormCheck } from "react-bootstrap";
// import ShowExcel from "../ShowExcel";
import PinInput from "react-pin-input";
import { uplaodTollTxn } from "../../../../services/Store/Actions/fleetActions";
function BulkFastagAdd() {
  const [fileSave, setFileSave] = useState(null);
  const [loader, setLoader] = useState(false);
  const [bulkTransfer, setBulkTransfer] = useState(0);
  const [bulkTransferId, setBulkTransferId] = useState(null);
  const [isWithdraw, setIsWithdraw] = useState(false);
  const [pin, setPin] = useState("");
  const dispatch = useDispatch();
  const customId1 = "custom-id-download page";
  const notify1 = () =>
    toast.success("Template was downloaded successfully.", {
      toastId: customId1,
      pauseOnHover: false,
    });
  const customId2 = "custom-id-upload page";
  const notify2 = () =>
    toast.success("Transfer Driver Bulk updated successfully.", {
      toastId: customId2,
      pauseOnHover: false,
    });
  const customId3 = "custom-id-Salary-dispersed";
  const notify3 = () =>
    toast.success("Amount dispersed successfully to drivers.", {
      toastId: customId3,
      pauseOnHover: false,
    });
  const notify4 = () =>
    toast.success("Transfers added successfully", {
      toastId: customId3,
      pauseOnHover: false,
    });
  const downloadSalDisbursement = () => {
    let blob;
    blob = new Blob([
      "Vehicle Number" +
        "\t" +
        "Credit" +
        "\t" +
        "Debit" +
        "\t" +
        "Date & Time(DD-MM-YYYY HH:mm)" +
        "\t" +
        "Description" +
        "\t" +
        "Remarks" +
        "\t" +
        "Trip No." +
        "\t" +
        "Transfer Id",
    ]);

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `file.xls`; //name to changed here
    link.click();
    notify1();
  };
  const [modal, setModal] = useState(false);

  const toggleModal = () => {
    setModal(!modal);
  };

  const showModalAddDriver = () => {
    setModal(true);
  };

  const bulkTransferCall = () => {
    console.log("njnoeinr", fileSave);
    setLoader(true);
    dispatch(
      uplaodTollTxn({ file: fileSave }, (res) => {
        console.log(res);
        setLoader(false);
        if (res.status == 200) {
          notify4();
        } else {
          toast.error(res.data?.message || "some error occured");
        }
      })
    );
  };
  console.log("isWithdrawisWithdrawisWithdraw", isWithdraw);
  return (
    <div
      style={{
        backgroundColor: "#ededf1",
        marginTop: "5px",
        border: "1px solid #E2E2E2",
        borderRadius: "5px",
      }}
    >
      <div
        style={{
          width: "auto",
          margin: "3px 0 0 30%",
          borderRadius: "10px",
        }}
      >
        <div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div
              className="col-lg-3"
              style={{ padding: "10px" }}
              onClick={downloadSalDisbursement}
            >
              <div className="svgContainerUp" style={{ margin: "0 23px" }}>
                <SvgImage name="Download" />
              </div>
              <div className="Bold300" style={{ textAlign: "center" }}>
                Download Template
              </div>
            </div>
            <div className="col-lg-3" style={{ padding: "10px" }}>
              <label for="file-upload2" class="custom-file-upload-3">
                <input
                  id="file-upload2"
                  type="file"
                  onChange={async (e) => {
                    const img = e?.target.files[0];
                    setFileSave(img);
                    console.log("image...", e?.target.files[0]);
                    setBulkTransfer(1);
                    notify2();
                  }}
                />
                <div
                  className="svgContainerUp"
                  style={{
                    margin: "0px 23px",
                    backgroundColor: bulkTransfer > 0 ? "antiquewhite" : null,
                  }}
                >
                  <SvgImage name="Upload" />
                </div>
                <div className="Bold300" style={{ textAlign: "center" }}>
                  Upload for bulk Transfers
                </div>
              </label>
            </div>
          </div>
        </div>
        {bulkTransfer == 1 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "-10px",
            }}
          >
            <div style={{ margin: ".5rem" }}>
              <a disabled={loader} style={{ margin: ".5rem" }} href={fileSave}>
                {fileSave?.name || "test"}
              </a>
            </div>
            {/* <ShowExcel
        toggle={toggleModal}
        modal={modal}
        setModal={setModal}
        fileSave={fileSave}
      /> */}
            <div>
              <Button
                className="greenButton"
                style={{ margin: ".5rem" }}
                onClick={bulkTransferCall}
                disabled={loader}
              >
                {" "}
                Transfer
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default BulkFastagAdd;
